<template>
    <div class="main">

        <c-panel>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Relatórios</label>
                    <el-select v-model="tipo">
                        <el-option :key="1" label="LIVRO DE MATRÍCULA" :value="1"></el-option>
                        <el-option :key="2" label="ATA DE RESULTADOS FINAIS" :value="2"></el-option>                  
                    </el-select>
                </el-col>
            </el-row>
        </c-panel>

        <div v-if="tipo == 1" class="u-mt-10">
            <livro-matricula></livro-matricula>
        </div>

        <div v-if="tipo == 2" class="u-mt-10">
            <resultados-finais></resultados-finais>
        </div>        
    </div>
</template>
<script>

import livroMatricula from "./livro-matricula"
import resultadosFinais from "./resultados-finais"

export default {
    data: () => ({
        tipo: 1
    }),
    mounted () {

    },
    methods: {
        text(){


        }
    },
    components:{ livroMatricula, resultadosFinais }
}
</script>